import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../../store';

import { PassengersSegmentedCount } from '@ibe.models/passenger.model.indra.lib';
import { INDRAFeature } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';

import { ANCILLARY_PRODUCT_GROUP_CODE_PREMIUM_CUSTOMER_CENTER } from '@ibe.config';

@Component({
	selector: 'app-flight-premium-customer-centre',
	templateUrl: './premium-customer-centre.indra.component.html',
	styleUrls: ['./premium-customer-centre.component.scss']
})
export class INDRAFlightPremiumCustomerCentreComponent implements OnInit, OnDestroy {

	flight;
	brand: string;
	feature: INDRAFeature;

	isAlive = true;

	passengers$: Observable<PassengersSegmentedCount> = this.store.select(fromStore.getMiniIBEPassengers);
	passengerList;
	reviewFlights: boolean = false;
	timeToThinkFlights: boolean = false;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private store: Store<fromStore.State>,
		private ancillariesService: INDRAAncillariesService,
		private bookingService: INDRABookingService
	) {
	}

	ngOnInit() {

		if (this.router.url.includes('/review-your-trip')) this.reviewFlights = true;
		if (this.router.url.includes('/time-to-think')) this.timeToThinkFlights = true;
		this.brand = this.route.snapshot.paramMap.get('brand');

		this.passengers$
			.pipe(takeWhile(() => this.isAlive))
				.subscribe(value => {
				if (value) {
					// generate generic passenger list according to type and count
					this.passengerList = this.ancillariesService.INDRA_generateGenericPassengerList(value);
				}
			});

		// Note: There are three flows where this sidebar will be shown - flight search result page, review your trip page, and in time to think page
		if (this.reviewFlights || this.timeToThinkFlights) {
			const flightIdentifier = this.route.snapshot.paramMap.get('flight');
			const flightObj = this.bookingService.INDRA_getBookedFlight(flightIdentifier);
			this.flight = this.bookingService.INDRA_getFlightRoute(flightObj);
			this.feature = this.bookingService.INDRA_getIncludedFeature(
				ANCILLARY_PRODUCT_GROUP_CODE_PREMIUM_CUSTOMER_CENTER, this.flight.idFlight.toString(), '');
		} else {
			// get flight and feature object from the data obj passed into the sidebarservice
			const parameters = this.sidebarService.getSidebarParameters();
			if (parameters && parameters.length) {
				this.flight = parameters[0].flightInfo;
				this.feature = parameters[0].feature;
			}
		}
	}


	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.closeSidebar(); }


	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_printImage() {
		const IMAGE = 'premiumcenter.jpg';
		return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
	}

}
